import { render, staticRenderFns } from "./NotificationTopBar.vue?vue&type=template&id=315e3d71"
import script from "./NotificationTopBar.vue?vue&type=script&lang=js"
export * from "./NotificationTopBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315e3d71')) {
      api.createRecord('315e3d71', component.options)
    } else {
      api.reload('315e3d71', component.options)
    }
    module.hot.accept("./NotificationTopBar.vue?vue&type=template&id=315e3d71", function () {
      api.rerender('315e3d71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/notification/NotificationTopBar.vue"
export default component.exports